import React from "react";
import { cn } from "@/utils/helpers";
import SvgIcon, { SvgIconProps } from "./SvgIcon";
import styles from "../Svg.module.css";

export default function SvgIconSearch({
	className,
	...props
} : SvgIconProps) {
	return (
		<SvgIcon
			className={cn(styles.SvgIconSearch, className)}
			{...props}
		>
			<path d="M38.5996 0.0507812C57.4967 1.00717 72.5244 16.6318 72.5244 35.7666L72.4824 37.5996C72.065 45.8485 68.8506 53.359 63.7705 59.2051L98.4805 93.915L92.3926 100.003L57.377 64.9863C51.551 69.1025 44.4417 71.5235 36.7666 71.5244L34.9248 71.4824C16.6362 70.5569 1.97637 55.8882 1.05078 37.5996L1 35.7666C1 16.0156 17.0156 0 36.7666 0L38.5996 0.0507812ZM36.7666 8.60938C21.7705 8.60938 9.60938 20.7705 9.60938 35.7666C9.61166 50.7608 21.7719 62.915 36.7666 62.915C51.7594 62.9128 63.9128 50.7594 63.915 35.7666C63.915 20.7719 51.7608 8.61166 36.7666 8.60938Z" />
		</SvgIcon>
	)
}
